export default {
  namespaced: true,
  state: {
    installations: [],
    installation: null,
    actions: [],
    action: null,
    categories: [],
    groups: [],
    products: [],
    meta: {},
  },
  actions: {
    GetCustomerCode({ commit, rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        commit('setField', { name: 'customerCode', value: null });
        rootGetters.axl
          .post('profiles/api/customer-code/get', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', {
                name: 'customerCode',
                value: response.data.customer_code,
              });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetSkuName({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'skuProduct', value: null });
      commit('setField', { name: 'skuBarcode', value: null });
      return new Promise((resolve, reject) => {
        rootGetters.ax
          .post('actions/api/action/get-sku-name', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', {
                name: 'skuProduct',
                value: response.data.product,
              });
              commit('setField', {
                name: 'skuBarcode',
                value: response.data.barcode,
              });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetInstallationsList({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'installations', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl
          .post('installations/api/installation/list', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', {
                name: 'installations',
                value: response.data.installations,
              });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetProjectsList({ commit, rootGetters, dispatch }) {
      commit('setField', { name: 'legalPersonList', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.ax
          .post('installations/api/installation/get-projects-list')
          .then((response) => {
            if (response && response.data) {
              commit('setField', {
                name: 'projectsList',
                value: response.data.list,
              });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetInstallation({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'installation', value: null });
      return new Promise((resolve, reject) => {
        rootGetters.axl
          .post('installations/api/installation/view', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', {
                name: 'installation',
                value: response.data.installation,
              });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetProductsList({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'products', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.ax
          .post('actions/api/action/get-sku-names', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', {
                name: 'products',
                value: response.data.products,
              });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetActionsList({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'actions', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl
          .post('actions/api/action/current-list', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', {
                name: 'actions',
                value: response.data.actions,
              });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetAction({ commit, rootGetters, dispatch }, payload) {
      dispatch('ClearAction');
      if (payload.noClearInstallation === undefined) {
        dispatch('ClearInstallation');
      }
      return new Promise((resolve, reject) => {
        rootGetters.axl
          .post('actions/api/action/view', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', {
                name: 'action',
                value: response.data.action,
              });
              commit('setField', {
                name: 'categories',
                value: response.data.action.categories,
              });
              commit('setField', {
                name: 'groups',
                value: response.data.action.groups,
              });
              commit('setField', {
                name: 'products',
                value: response.data.action.products,
              });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    ClearAction({ commit }) {
      commit('setField', { name: 'action', value: null });
      commit('setField', { name: 'categories', value: [] });
      commit('setField', { name: 'groups', value: [] });
      commit('setField', { name: 'products', value: [] });
    },
    ClearInstallation({ commit }) {
      commit('setField', { name: 'installation', value: null });
    },
    ClearInstallations({ commit }) {
      commit('setField', { name: 'installations', value: [] });
    },
    InitialStore({ commit }) {
      commit('setField', { name: 'installations', value: [] });
      commit('setField', { name: 'installation', value: null });
      commit('setField', { name: 'actions', value: [] });
      commit('setField', { name: 'action', value: null });
      commit('setField', { name: 'categories', value: [] });
      commit('setField', { name: 'groups', value: [] });
      commit('setField', { name: 'products', value: [] });
      commit('setField', { name: 'meta', value: {} });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
    setInstallations(state, installations) {
      installations.forEach(item => state.installations.push(item));
    },
  },
};
